<ion-header>
  <ion-toolbar>
    <ion-title>Info-Anmeldung</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" style="--keyboard-offset: 200px;">
  
</ion-content>
